import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        errorTypeEnum: {
            anotherCampaignIsAlreadyStarted: 'Une autre campagne est en cours',
            ticketWasNotOpenedInTheElligiblePeriodForThisCampaign: 'Ce ticket est trop ancien pour être éligible dans cette campagne de satisfaction',
            alreadyExistSatisfactionCampaignAnswerForThisTicket: 'Une note de satisfaction a déjà été donnée pour ce ticket'
        },
        satisfaction: 'satisfaction',
    	campaign: 'campagne de satisfaction',
        newCampaign: 'nouvelle campagne de satisfaction',
        answer: 'réponse',
        answers: 'réponses',
        answerCount: 'nombre de réponses',
        answerRate: 'taux de réponses',
        answerRateGoal: 'objectif de taux de réponses',
        forAnswerGoal: 'pour un objectif de {answerGoal}%',
        question: 'question',
        questions: 'questions',
        notationScale: 'échelle de notation',
        notationScalePosition: 'position',
        notationScaleLabel: 'réponse',
        addNotationScale: 'ajouter',
        synthesis: 'synthèse',
        ticket: 'ticket',
        rate: 'taux',
        score: 'notation',
        averageScore: 'note moyenne',
        start: 'activer',
        startCampaign: 'activer la campagne',
        startCampaignText: [
            'Vous êtes sur le point d\'activer la campagne de satisfaction {title}.',
            'Attention, une fois démarrée, il ne vous sera plus possible d\'ajouter de questions ou de modifier l\'échelle de notation.'
        ],
        finish: 'arrêter',
        finishCampaign: 'arrêter la campagne',
        finishCampaignText: [
            'Vous êtes sur le point d\'arrêter la campagne de satisfaction {title}.',
            'Attention, une fois arrêtée, il ne vous sera plus possible de redémarrer la campagne, il vous faudra en créer une nouvelle.'
        ],
        elligibleTicketDate: 'date d\'éligibilité des tickets',
        outOfEligibleTicketCount: 'sur {ticketCount} tickets éligibles',
        globalComment: 'Commentaire général'
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/satisfaction/i18n.js